import { ComboBox } from "@progress/kendo-react-dropdowns";
import { useState } from "react";

type Props = {
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
};

const customerTeamOptions = [
  "Tennessee",
  "Mexico",
  "Dayton",
  "Grand Rapids",
  "Truckload",
  "Specialized",
  "Solutions",
  "Indirect/3PL",
  "Manufacturing",
  "Government",
  "Automotive",
  "Heavy Trucks",
  "Energy and Utilities",
  "Life Sciences and Healthcare",
  "Events and Entertainment",
  "Heavy Truck-Shuttle",
  "Aerospace"
];

const CustomerTeamInput = ({ value, disabled, onChange }: Props) => {
  const [options, setOptions] = useState(customerTeamOptions);

  return <ComboBox
    allowCustom
    clearButton
    disabled={disabled}
    filterable
    ignoreCase
    className="k-dropdown-wrap-append flex-fill"
    data={options}
    inputAttributes={{ maxLength: 40 }}
    value={value}
    onFilterChange={(e) => {
      const filter = e.filter.value.toLowerCase();
      setOptions(customerTeamOptions.filter((option) => option.toLowerCase().includes(filter)));
    }}
    onChange={(e) => onChange(e.value?.substring(0, 40))}
  />;
};

export default CustomerTeamInput;
